import { render, staticRenderFns } from "./FilterRating.vue?vue&type=template&id=b08e0980"
import script from "./FilterRating.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterRating.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilterRating.vue?vue&type=style&index=0&id=b08e0980&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports